export enum PrescriptionOption {
  Recipes = 1,
  Notifications = 2,
  RequestLens = 3,
  RequestInternalManufacturing = 4,
  StartChecking = 5,
  Approve = 6,
  Disapprove = 7,
  RequestExternalManufacturing = 8,
  RecipesV2 = 9,
  NotificationsV2 = 10,
  RecipesForPhysicalStore = 11
}